// utils/getExcerpt.js

/**
 * Convierte markdown crudo en texto plano apto para preview,
 * y lo trunca a maxLength caracteres.
 */
export const getExcerpt = (markdown, maxLength = 160) => {
   if (!markdown) return '';

   const plainText = markdown
      // Quita imágenes ![alt](url)
      .replace(/!\[.*?\]\(.*?\)/g, '')
      // Quita links mantiene el texto [texto](url) -> texto
      .replace(/\[([^\]]+)\]\(.*?\)/g, '$1')
      // Quita encabezados ###, ##, #
      .replace(/^#{1,6}\s+/gm, '')
      // Quita negrita/itálica **texto** *texto*
      .replace(/(\*\*|__)(.*?)\1/g, '$2')
      .replace(/(\*|_)(.*?)\1/g, '$2')
      // Quita marcas de lista (-, *, 1.)
      .replace(/^\s*[-*+]\s+/gm, '')
      .replace(/^\s*\d+\.\s+/gm, '')
      // Quita líneas horizontales ---
      .replace(/^-{3,}$/gm, '')
      // Quita blockquotes >
      .replace(/^>\s?/gm, '')
      // Quita bloques de código ``` y `inline`
      .replace(/```[\s\S]*?```/g, '')
      .replace(/`([^`]+)`/g, '$1')
      // Colapsa saltos de línea múltiples en un espacio
      .replace(/\n+/g, ' ')
      .trim();

   if (plainText.length <= maxLength) return plainText;

   return plainText.slice(0, maxLength).trimEnd() + '…';
};